<!-- 
PROPS:
- Preguntas -> Se pasa un objecto con el siguiente formato:
  - enunciado -> Texto
  - opciones -> Arreglode texto con opciones
  - respuesta -> respuesta correcta usando la posición de la respuesta en el arreglo
  - retroalimentacionBien -> Texto de retroalimentación cuando responde bien
  - retroalimentacionMal  -> Texto de retroalimentación cuando responde mal
-->
<template>
    <v-layout wrap align-end>
      <v-flex xs12 sm3 lg2 order-xs1 order-sm1>
        <div>
          <Barril class="barril" :viewBox="$vuetify.breakpoint.xs?'0 50 997 400':'0 50 340 400'" :progress="progress"></Barril>
        </div>
      </v-flex>
      <v-flex xs4 sm3 lg2 order-xs3 hidden-sm-and-down>
        <div>
          <Barril class="barril" viewBox="650 50 340 400"></Barril>
        </div>
      </v-flex>
      <v-flex v-if="!mostrarResultado" xs12 sm8 md6 lg8 order-sm2 class="hilo">
        <v-layout row wrap justify-center align-center>
            <!-- Íconos de preguntas  -->
            <v-flex xs12>
              <p><span class="numero">{{actual+1}}. </span><span v-html="preguntas[actual].enunciado"></span></p>
              <ol>
                <li v-for="(opcion, index) in preguntas[actual].opciones" :key="'op'+index" @click="validarRespuesta(index)" :class="{'disabled': retroalim, 'bien': retroalim && !reintentarBoton && seleccionada == index, 'mal': retroalim && reintentarBoton && seleccionada == index}">
                  <label class="hvr">
                    <input type="radio" :name="'pregunta'+actual" :disabled="retroalim"/>{{opcion}}
                  </label>
                </li>
              </ol>
            </v-flex>
            <v-flex xs12 class="retroalim-flex">
              <transition name="text" enter-active-class="animated fadeIn superfaster" leave-active-class="animated fadeOut superfaster">
                <div v-if="retroalim" class="pa-2 text-xs-center">
                  <p class="bold mt-3" :class="reintentarBoton? 'mal': 'bien'">{{retroalimText}}</p>
                  <br>
                  <v-btn v-if="retroalim && actual < preguntas.length - 1" @click="siguiente()" color="#84dff4"><v-icon>arrow_forward</v-icon>Siguiente</v-btn>
                  <v-btn v-if="actual >= preguntas.length - 1" @click="verResultado()" color="#84dff4">Ver resultado</v-btn>
                  <!-- <v-btn v-if="reintentarBoton" @click="reintentar()" color="#ff8f00" class="bold" ><v-icon>replay</v-icon>Reintentar</v-btn>
                  <v-btn v-if="!reintentarBoton && actual < preguntas.length - 1" @click="siguiente()" color="#84dff4"><v-icon>arrow_forward</v-icon>Siguiente</v-btn> -->
                </div>
              </transition>
            </v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-else text-xs-center xs12 sm8 md6 lg8 order-sm2 class="hilo">
        <img class="animated bounceIn" :src="barrilImg" alt="">
        <br>
        <v-btn v-if="progress<0.5 && intentos == 0" @click="reintentar()" color="#ff8f00" class="bold" ><v-icon>replay</v-icon>Reintentar</v-btn>
      </v-flex>
    </v-layout>
</template>
<script>
import Barril from '../assets/Modulo 1/diapositiva-14'
export default {
    props: ['preguntas','imagenes'],
    components: {
      Barril
    },
    data () {
        return {
            actual: 0,
            mostrarImagen: false, //Si la pregunta está basada en una imagen, muestra la imagen
            retroalim: false,
            retroalimText: '',
            retroalimClass: '', // bien o mal
            seleccionada: -1,
            modal: false,
            cerrar: '',
            icons: [],
            correctas: [],
            imgBienBot: '',
            imgMalBot: '',
            intentos: 0,
            reintentarBoton: false,
            mostrarResultado: false,
            nopreguntascorrectas: 0,
            preguntasContestadas: 0 //Contador
        }
    },
    created(){
      this.correctas = Array(this.preguntas.length).fill(false)
    },
    computed: {
      progress: function() {
        return this.nopreguntascorrectas / this.preguntas.length
      },
      medalla: function(){
        if(this.progress == 1){
          return 'oro'
        }
        if(this.progress >= 0.75){
          return 'plata'
        }
        if(this.progress >= 0.5){
          return 'bronce'
        }
        return 'nada'
      },
      barrilImg: function(){
        switch(this.medalla){
          case 'oro': return require('../../src/assets/presentacion/diapositiva-5-1.png')
          case 'plata': return require('../../src/assets/presentacion/diapositiva-5-2.png')
          case 'bronce': return require('../../src/assets/presentacion/diapositiva-5-3.png')
          default: return require('../../src/assets/presentacion/diapositiva-5-4.png')
        }
      }
    },
    methods: {
        validarRespuesta(resp){
          if(this.retroalim) return;
            this.seleccionada = resp
            // Ocultar todas las opciones excepto la seleccionadas
            var opciones = Array.from(document.querySelectorAll('.opcion'))
            opciones.forEach(element => {
              if (element.id != "opcion"+resp) {
                element.style.display = 'none'
              }
            });
            // Validar y agregar retroalimentación
            if (resp == this.preguntas[this.actual].respuesta){
                this.retroalimText = this.preguntas[this.actual].retroalimentacionBien
                this.retroalimClass = 'bien'
                this.correctas[this.actual] = true
                this.reintentarBoton = false
                // Solo avanza hasta que reponda bien la pregunta actual (la condición es para prevenir que no avance si responde la misma pregunta varias veces)
                // if(this.preguntasContestadas<=this.actual)
                this.preguntasContestadas++
                this.nopreguntascorrectas++
            }else{
                this.retroalimText = this.preguntas[this.actual].retroalimentacionMal
                this.retroalimClass = 'mal'
                this.reintentarBoton = true
            }
            this.retroalim = true;
            if (this.preguntasContestadas>=this.preguntas.length){
              this.$emit('actividadFinalizada')
            }
        },
        verResultado(){
          this.$emit('resultado',this.medalla,this.intentos)
          this.mostrarResultado = true
        },
        reintentar() {
          this.$emit('reintentar')
          this.preguntasContestadas = 0
          this.nopreguntascorrectas = 0
          this.actual = 0
          this.mostrarResultado = false
          this.clear()
          this.intentos++
        },
        clear(){
          // Devolver visibilidad a las opciones
          var opciones = Array.from(document.querySelectorAll('.opcion'))
          opciones.forEach(element => {
            element.style.display = ''
          });
          this.retroalim = false;
        },
        siguiente() {
          if(this.actual < this.preguntas.length - 1){
            this.actual += 1
            this.clear()
          }
        }
    }   
}
</script>
<style lang="scss" scoped>
@import '../sass/helpers/variables.scss';
.actividad-img {
  max-width: 50%;
  height: 15vh;
}

.icono-pregunta{
  position: relative;
}

.retroalim-bot{
  position: absolute;
  top: 0;
  left: calc(50% - 15px);
}

.opcion {
  border-radius: 5px;
}

ol {
  list-style-type: lower-alpha;
  counter-reset: item;
  li {
    display: flex;
    background-color: white;
    border: 1px dashed black;
    color: black;
    border-radius: 10px;
    margin-top: 5px;
    padding: 5px 10px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    &:hover {
      background-color: $yellow;
    }
    &.disabled {
      background-color: #eee;;
      // border-bottom: 2px solid lightgray;
      &.bien {
        background-color: $verde-cla;
      }

      &.mal {
          background-color: lighten(red,25%);
      }
    }
  }
  li:before {content: counter(item, lower-alpha) ". "; counter-increment: item; font-weight: bold;}
}


.bold {
  font-weight: bold;
}
.numero {
  font-weight: bold;
}

label {
  display: inline-block;
  position: relative;
  padding: 0 10px;
  max-width: calc(100% - 2rem);
}
input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.retroalim-flex{
  min-height: 8rem;
}

.descripcion {
  font-style: italic;
}

p.bien, p.mal {
  display: inline-block;
  background-color: white;
  padding: 5px 15px;
}
p.bien {
  color: green;
}
p.mal {
  color: red;
}

.barril {
  position: relative;
  bottom: -47px;
  @media (max-width: 600px){
    bottom: -33.5px;
  }
  @media (max-width: 900px){
    bottom: -33.5px;
  }
  @media (max-width: 1600px){
    bottom: -44.5px;
  }
}
.hilo {
  min-height: 40vh;
  border-bottom: 2px solid #1a1e1c;
}
</style>

